// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tj-0";
export var checkoutRateBadgeLink = "_tj-1";